import styled from 'styled-components';
import BackgroundBox from 'shared/components/BackgroundBox';

import { Modal } from 'shared/components/modal/Modals';
import { colors, fonts, fontSizes, device } from 'shared/defaultTheme';

export const CalendarBackground = styled(BackgroundBox)`
  #schedule_dialog_wrapper {
    min-height: 500px;
  }
  @media ${device.sm} {
    width: 97%;
    margin-left: 5px;
    .top-mobile {
      flex-direction: column;
    }
  }
  @media ${device.md} {
    width: 90%;
  }
  @media ${device.lg} {
    width: 90%;
  }
  @media ${device.xl} {
    width: 90%;
  }
`;

export const CalendarFormModal = styled(Modal)`
  top: 15%;
  .modal-content {
    border-radius: 4px;
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
  }
  .calendar-event-container {
    .row-title {
      border-bottom: 1px solid ${colors.spanishGray};
      padding-bottom: 17px;
      width: 100%;
      margin-left: 1px;
      h3 {
        color: ${colors.black};
        font-family: ${fonts.default};
        font-size: ${fontSizes.xlg}px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 24px;
      }
    }
  }
`;
